import type { LoginSession } from '@mathflat/domain/Auth'

export interface ElectronLoginPayload {
  accessToken: string
  refreshToken: string
  teacherId: string
}

export const notifyElectronLogin = ({
  accessToken,
  refreshToken,
  teacherId,
}: ElectronLoginPayload) => {
  window.electronAPI?.notifyLogin({
    accessToken,
    refreshToken,
    teacherId,
  })
}

export const notifyElectronLoginFromJwtLoginResponse = ({
  accessToken,
  refreshToken,
  userId,
}: Pick<LoginSession, 'accessToken' | 'refreshToken' | 'userId'>) => {
  notifyElectronLogin({
    accessToken,
    refreshToken,
    teacherId: userId,
  })
}

export const notifyElectronLogout = () => {
  window.electronAPI?.notifyLogout()
}
